import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ChatBubble = ({ isOpen, onToggle, unreadCount = 0 }) => {
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (unreadCount > 0) {
      setIsAnimating(true);
      const timer = setTimeout(() => setIsAnimating(false), 600);
      return () => clearTimeout(timer);
    }
  }, [unreadCount]);

  return (
    <div className="fixed bottom-6 right-6 z-50 md:hidden">
      <Button
        variant="default"
        size="icon"
        onClick={onToggle}
        className={`w-14 h-14 rounded-full shadow-prominent transition-all duration-300 ${
          isAnimating ? 'animate-bounce' : ''
        } ${isOpen ? 'bg-secondary' : 'bg-primary'}`}
      >
        <Icon 
          name={isOpen ? "X" : "MessageCircle"} 
          size={24} 
          color="white"
        />
        {unreadCount > 0 && !isOpen && (
          <span className="absolute -top-2 -right-2 bg-error text-error-foreground text-xs rounded-full w-6 h-6 flex items-center justify-center font-medium">
            {unreadCount > 9 ? '9+' : unreadCount}
          </span>
        )}
      </Button>
    </div>
  );
};

export default ChatBubble;